/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductHistoryItem } from './ProductHistoryItem';
import {
    ProductHistoryItemFromJSON,
    ProductHistoryItemFromJSONTyped,
    ProductHistoryItemToJSON,
    ProductHistoryItemToJSONTyped,
} from './ProductHistoryItem';

/**
 * 
 * @export
 * @interface ProductHistoryResponse
 */
export interface ProductHistoryResponse {
    /**
     * 
     * @type {Array<ProductHistoryItem>}
     * @memberof ProductHistoryResponse
     */
    productHistoryItems: Array<ProductHistoryItem>;
}

/**
 * Check if a given object implements the ProductHistoryResponse interface.
 */
export function instanceOfProductHistoryResponse(value: object): value is ProductHistoryResponse {
    if (!('productHistoryItems' in value) || value['productHistoryItems'] === undefined) return false;
    return true;
}

export function ProductHistoryResponseFromJSON(json: any): ProductHistoryResponse {
    return ProductHistoryResponseFromJSONTyped(json, false);
}

export function ProductHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductHistoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'productHistoryItems': ((json['productHistoryItems'] as Array<any>).map(ProductHistoryItemFromJSON)),
    };
}

export function ProductHistoryResponseToJSON(json: any): ProductHistoryResponse {
    return ProductHistoryResponseToJSONTyped(json, false);
}

export function ProductHistoryResponseToJSONTyped(value?: ProductHistoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'productHistoryItems': ((value['productHistoryItems'] as Array<any>).map(ProductHistoryItemToJSON)),
    };
}

